import type { CustomIconProps } from '../types';

export default function ElevatorIcon({ size = 24, className, strokeWidth }: CustomIconProps) {
  // Source artwork is drawn on a 64x64 viewBox at stroke-width 2 — lucide
  // icons use the same stroke-width on a 24x24 viewBox, i.e. roughly 2.5x
  // thinner relatively, so scale up here to match.
  const stroke = (strokeWidth ?? 2) * (64 / 24);
  return (
    <svg width={size} height={size} viewBox="2 0 60 60" fill="none" className={className}>
      <g stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 14a11 11 0 0 1 22 0H17Z" />
        <path d="M28 12V8" />
        <path d="M8 58V17h40v41" />
        <path d="M14 58V23h28v35M28 23v35" />
        <path d="m52 30 3.5-4 3.5 4M52 36l3.5 4 3.5-4" />
        <path d="M6 58h44" />
      </g>
    </svg>
  );
}
